import { render, staticRenderFns } from "./AnnualPhysicalExam.vue?vue&type=template&id=2a97307a&scoped=true"
import script from "./AnnualPhysicalExam.vue?vue&type=script&lang=js"
export * from "./AnnualPhysicalExam.vue?vue&type=script&lang=js"
import style0 from "./AnnualPhysicalExam.vue?vue&type=style&index=0&id=2a97307a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97307a",
  null
  
)

export default component.exports